import PropTypes from "prop-types";
import { useState } from "react";
import { useRouter } from "next/router";
import Input from "components/shared/input/Input";

import { Title, Search, SearchTitle, HeroBanner } from "./Hero.styled";

export default function Hero({ breadcrumbsItems, searchTerm }) {
    const [term, setTerm] = useState(searchTerm);

    const router = useRouter();

    function handleSubmit(event) {
        event.preventDefault();

        if (term) {
            router
                .push(`/helpdesk/zoekresultaten?q=${term}`)
                .then(() => window.scrollTo(0, 0));
        }
    }

    return (
        <HeroBanner breadcrumbs={breadcrumbsItems}>
            <Title>
                Hoe kunnen we je <strong>helpen</strong>?
            </Title>
            <Search onSubmit={handleSubmit}>
                <SearchTitle>Stel je vraag</SearchTitle>
                <Input
                    name="helpdeskHeroSearch"
                    leftIconTop={50}
                    leftIcon={
                        <img
                            src="/images/icon-search.svg"
                            alt="Zoeken"
                            loading="lazy"
                            width={15}
                            height={15}
                        />
                    }
                    onChange={event => setTerm(event.target.value)}
                    placeholder="Vul hier je vraag in"
                    value={term}
                />
            </Search>
        </HeroBanner>
    );
}

Hero.propTypes = {
    breadcrumbsItems: PropTypes.array,
    searchTerm: PropTypes.string
};

Hero.defaultProps = {
    breadcrumbsItems: [
        {
            title: "Helpdesk",
            url: "/helpdesk"
        }
    ],
    searchTerm: ""
};
